import React from 'react';

export const ScoringRules = () => {
  return (
    <div className="mt-8 bg-zinc-100 p-6 rounded-lg border border-zinc-200">
      <h3 className="text-lg font-bold mb-4 text-zinc-900">Texnik Xallanma Qaydaları</h3>
      <ul className="space-y-3 text-sm">
        <li className="flex items-center gap-3 text-zinc-700">
          <span className="inline-flex items-center justify-center w-16 h-8 bg-green-100 text-green-700 font-bold rounded-lg">+10</span>
          <span>Uğurlu bağlanan ticket</span>
        </li>
        <li className="flex items-center gap-3 text-zinc-700">
          <span className="inline-flex items-center justify-center w-16 h-8 bg-red-100 text-red-700 font-bold rounded-lg">-20</span>
          <span>Operator tərəfindən geri qaytarılan (keyfiyyətsiz iş)</span>
        </li>
        <li className="flex items-center gap-3 text-zinc-700">
          <span className="inline-flex items-center justify-center w-16 h-8 bg-yellow-100 text-yellow-700 font-bold rounded-lg">+5</span>
          <span>1 gündən gecikmiş ticketin tamamlanması</span>
        </li>
        <li className="flex items-center gap-3 text-zinc-700">
          <span className="inline-flex items-center justify-center w-16 h-8 bg-red-100 text-red-700 font-bold rounded-lg">-20</span>
          <span>4 gün keçən ticket avtomatik geri qaytarılır</span>
        </li>
        <li className="flex items-center gap-3 text-zinc-700">
          <span className="inline-flex items-center justify-center w-16 h-8 bg-green-100 text-green-700 font-bold rounded-lg">+20</span>
          <span>Geri qaytarılan ticketi 1 gün ərzində həll edilməsi</span>
        </li>
        <li className="flex items-center gap-3 text-zinc-700">
          <span className="inline-flex items-center justify-center w-16 h-8 bg-green-100 text-green-700 font-bold rounded-lg">+10</span>
          <span>Geri qaytarılan ticketi 3 gün ərzində həll edilməsi</span>
        </li>
      </ul>
      
      <h3 className="text-lg font-bold mb-4 mt-6 text-zinc-900">Operator Xallanma Qaydaları</h3>
      <ul className="space-y-3 text-sm">
        <li className="flex items-center gap-3 text-zinc-700">
          <span className="inline-flex items-center justify-center w-16 h-8 bg-blue-100 text-blue-700 font-bold rounded-lg">+5</span>
          <span>Yeni ticket yaratmaq</span>
        </li>
        <li className="flex items-center gap-3 text-zinc-700">
          <span className="inline-flex items-center justify-center w-16 h-8 bg-green-100 text-green-700 font-bold rounded-lg">+10</span>
          <span>Ticket bağlamaq (yoxlama tamamlandı)</span>
        </li>
      </ul>
    </div>
  );
};

export default ScoringRules;
